import _ from 'lodash'

/**
 * @description If the "value" arg is an object, it returns the data as a stringified array
 * @exampleInput obj - {"city": "Billing city","country": "Billing country"}
 * @exampleOutput string - '"Billing city", "Billing country"'
 * @param {*} value Any type
 * @returns string number or array
 */
export const parseValue = (value) => {
  let _value = value
  if (_value && !_.isArray(_value) && _.isObject(_value) && !(_value instanceof Date)) {
    _value = _.compact(_.values(_value)).join(', ')
  }
  return _value
}

/**
 * @description Maps values from array
 * @param {*} value Array of any type
 * @returns array of string or number or array
 */
export const parseArrayValues = (values) => {
  const result = _.map(values, (value) => {
    const _value = parseValue(value)
    return _value
  })
  return result
}
